const faqCategories=document.querySelectorAll('.faq_category'); // Les éléments du nav de gauche
const singleFaqs=document.querySelectorAll(".faq__content__right__singleFaq"); // Chaque question-réponse individuellement

faqCategories.forEach(function(faqCategory) {
  faqCategory.addEventListener('click', function() {
    let category = faqCategory.getAttribute('id')
    let singleCategoryFaqs = []
    //D'abord on enroule la question active
    singleFaqs.forEach(singleFaq => {
      singleFaq.classList.remove('current','active')
    });
    //on souligne la catégorie cliquée, on desouligne la précedente
    let current = document.querySelector('.current')
    if (current !== faqCategory) {
      current.classList.remove('current')
    }
    faqCategory.classList.add('current')

    setTimeout(function(){
      //on affiche les quesions concernées, on efface les autres
      for (let i = 0; i < singleFaqs.length; i++) {
        let singleFaq = singleFaqs[i]
        let singleFaqCategory = singleFaq.getAttribute('id')
        //singleFaq.classList.remove('current')
        if (singleFaqCategory === category) {
          singleCategoryFaqs.push(singleFaq)
          setTimeout(function(){
            singleFaq.classList.add('current')
            singleCategoryFaqs[0].classList.add('active') // pour afficher la première réponse
          }, 900);
        }
        if (category == 'all_faq_categories') {
          setTimeout(function(){
            singleFaq.classList.add('current')
            if (i == 0) {
              singleFaq.classList.add('active')
            }
          }, 900);
        }
      }
    }, 200);
  });
});
// Quand on clique sur une question, la réponse s'affiche, la précédente s'efface
singleFaqs.forEach(singleFaq => {
  let question=singleFaq.querySelector('.question')
  question.addEventListener('click', function(){
    let active = document.querySelector('.active')
    if( active && active !== singleFaq ){
      active.classList.remove('active')
    }
    setTimeout(function(){
      singleFaq.classList.toggle('active')
    }, 1000);
  });
});
